import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
import log from "cslog";
import PhotoAlbum from "react-photo-album";

function Gallery({ id, db, device, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    // const ss = decodeStyle(ps.style, gs);

    // log.d(input, "Input in Gallery");

    return (
        <div>
            <PhotoAlbum
                layout={input.galleryLayout}
                photos={
                    input.photos.length > 0
                        ? input.photos.map((item) => {
                              return {
                                  src: item.full,
                                  width: item.width,
                                  height: item.height,
                              };
                          })
                        : [
                              {
                                  width: 200,
                                  height: 150,
                                  src: "/img_pp.png",
                              },
                              {
                                  width: 200,
                                  height: 200,
                                  src: "/img_pp.png",
                              },
                          ]
                }
                // columns={columns}
                spacing={input.spacing / 2}
                padding={0}
                // targetRowHeight={200}
            />
        </div>
    );
}

export default Gallery;
